function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "inmobiliaria",
  transform: "translate(-316.585 -334.403)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_84",
  "data-name": "Grupo 84"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_43",
  "data-name": "Trazado 43",
  className: "cls-1",
  d: "M333.894,339.964l-12.346,10.178a.291.291,0,0,1-.011.064.31.31,0,0,0-.011.065v10.306a1.393,1.393,0,0,0,1.374,1.374h8.245v-8.245h5.5v8.246h8.245a1.4,1.4,0,0,0,1.374-1.375V350.271a.3.3,0,0,0-.021-.129Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_44",
  "data-name": "Trazado 44",
  className: "cls-1",
  d: "M350.963,347.823l-4.7-3.908v-8.76a.662.662,0,0,0-.687-.687h-4.123a.661.661,0,0,0-.687.687v4.187l-5.238-4.38a2.662,2.662,0,0,0-3.264,0l-15.438,12.861a.621.621,0,0,0-.236.462.69.69,0,0,0,.15.5l1.331,1.589a.734.734,0,0,0,.451.237.8.8,0,0,0,.516-.151l14.858-12.389,14.858,12.389a.66.66,0,0,0,.451.15h.064a.728.728,0,0,0,.451-.236l1.331-1.589a.691.691,0,0,0,.15-.505A.624.624,0,0,0,350.963,347.823Z"
})));

function SvgInmobiliaria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.616,
    height: 27.549,
    viewBox: "0 0 34.616 27.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInmobiliaria);
export default __webpack_public_path__ + "static/media/inmobiliaria.e2dcbb6a.svg";
export { ForwardRef as ReactComponent };